import { c as _c } from "react/compiler-runtime";
/**
 * 상담 신청 랜딩 — HERO 섹션
 * Figma node 2921:12874 (HERO) / 2921:12877 (div.wrap), Mobile 2921:13578 (file N392FVYByl0g8V8bbqHxn9) 기준.
 * - PC: 좌측 카피 + 우측 비주얼(노트북 사진 위 AI 채팅 카드) 2단 구성, 상단 정렬(items-start).
 * - 모바일: 비주얼이 위, 카피가 아래(가운데 정렬)로 스택.
 * - 표준 Tailwind 반응형(sm/md/lg)만 사용. globals.css 의 fs/dynamic-size 시스템 미사용.
 * - 폰트: eyebrow = NanumSquare Neo Regular, h1 = NanumSquare Neo ExtraBold, sub/CTA/진료과목 = Pretendard(전역).
 */

/** 노트북 사진 + AI 채팅 카드 오버레이 비주얼.
 *  Figma "Img" 노드(2923:9361): 컨테이너 465.667×299, 사진 left 40.77px / w 424.557, 채팅 카드 좌측 오버레이. */
const HeroVisual = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-y-0 right-0 w-[91.17%] overflow-hidden rounded-xl"><img src="/inquiry-landing/hero/hero-photo.png" alt={"\uB178\uD2B8\uBD81\uC73C\uB85C AI\uC5D0\uAC8C \uBCD1\uC6D0 \uCD94\uCC9C\uC744 \uAC80\uC0C9\uD558\uB294 \uBAA8\uC2B5"} width={840} height={592} loading="eager" fetchPriority="high" className="h-full w-full object-cover" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex w-full items-center justify-between rounded-[3px] bg-[#02111a] px-[4.3%] py-[1.2%]"><div className="flex min-w-0 items-center"><p className="truncate font-medium text-[clamp(7px,2.15vw,10px)] leading-[1.86] text-[#efefef]">나에게 어떤 병원이 좋을지 추천해줘.</p><span className="ml-px h-[55%] w-px shrink-0 rounded-full bg-[#9fc1ce]" aria-hidden={true} /></div><img src="/inquiry-landing/hero/icon-send.svg" alt="" aria-hidden={true} width={16} height={16} className="ml-1 size-[6.8%] min-w-[12px] max-w-[16px] shrink-0" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="flex aspect-square w-[7.4%] min-w-[12.6px] max-w-[17.2px] shrink-0 items-center justify-center rounded-[1.7px] bg-[#2ba895] font-bold text-[clamp(6px,1.85vw,8.6px)] leading-none tracking-[-0.34px] text-white">AI</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="font-bold text-[clamp(6px,2vw,9.3px)] leading-[1.4] text-[#29dfc3]">AI 추천 답변</p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="relative aspect-[465.667/299] w-full max-w-[466px] shrink-0 lg:w-[466px]">{t0}<div className="pointer-events-none absolute left-[24.95%] top-[28.46%] w-[49.92%] max-w-[232px] -translate-x-1/2 -translate-y-1/2"><div className="flex flex-col items-center gap-[8.6px] rounded-[10px] border-[0.7px] border-solid border-[#4784a4]/80 bg-[#043e5a]/80 p-[8.6%] shadow-[0px_2.9px_2.9px_0px_rgba(0,0,0,0.25)] backdrop-blur-[4.65px]">{t1}<div className="flex w-full items-start gap-[2.5%]">{t2}<div className="flex flex-col gap-[5.7px]">{t3}<p className="break-keep font-medium text-[clamp(6px,2vw,9.3px)] leading-[1.4] text-[#efefef]">강남 지역에서는 <span className="font-semibold">A피부과</span>가 환자 만족도가 높은곳으로 자주 언급됩니다. 실제 방문 후기에서도 좋은 평가를 받고 있습니다.</p></div></div></div></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
const Hero = () => {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      backgroundImage: "radial-gradient(70% 43% at 78% 8%, rgba(238,241,244,1) 0%, rgba(238,241,244,0) 60%), radial-gradient(62% 53% at 8% 90%, rgba(238,241,244,0.1) 0%, rgba(238,241,244,0) 55%)"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="order-1 flex w-full shrink-0 justify-center lg:order-2 lg:w-[466px] lg:justify-end"><HeroVisual /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="break-keep font-[family-name:var(--font-nanum-square-neo)] text-[16px] leading-[1.43] tracking-[-0.25px] text-[#5e5e5e] lg:text-[18px]">리뷰 노출 서비스</p>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h1 className="break-keep font-[family-name:var(--font-nanum-square-neo)] text-[34px] font-extrabold leading-[1.35] tracking-[-1.19px] text-[#121212] sm:text-[42px] sm:tracking-[-1.5px] lg:text-[56px] lg:leading-[1.34] lg:tracking-[-2.03px]">잘 관리된 리뷰,<br aria-hidden={true} />AI에게 노출시켜야 합니다.</h1>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <br aria-hidden={true} className="hidden lg:inline" />;
    t5 = <br aria-hidden={true} className="sm:hidden" />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  let t7;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br aria-hidden={true} className="hidden lg:inline" />;
    t7 = <br aria-hidden={true} className="sm:hidden" />;
    t8 = <span className="font-semibold">리뷰드</span>;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="flex w-full flex-col items-center justify-between gap-[30px] py-[7.5px] lg:flex-row lg:items-start lg:gap-12 lg:py-2.5">{t1}<div className="order-2 flex w-full flex-col items-center gap-[30px] text-center lg:order-1 lg:flex-1 lg:items-start lg:gap-12 lg:text-left"><div className="flex w-full flex-col items-center gap-3 lg:items-start lg:gap-3.5">{t2}<div className="flex w-full flex-col items-center gap-5 lg:items-start lg:gap-[21px]">{t3}<div className="w-full max-w-[520px] break-keep text-[17px] leading-[1.45] text-[#121212] lg:text-[18px]"><p>네이버에 정성껏 쌓아온 우리 병원의 좋은 리뷰. {t4}{t5}정작 환자들이 AI에게 물어볼 때는 보이지 않습니다. {t6}{t7}{t8}는 병원의 관리된 리뷰를 <br aria-hidden={true} className="sm:hidden" /><span className="font-semibold">인공지능과 사람 모두에게 노출</span>합니다.</p></div></div></div><a href="#apply" className="inline-flex h-[58px] w-full items-center justify-center rounded-[40px] bg-primary-600 px-[22px] text-[18px] font-semibold text-white transition-colors duration-200 hover:bg-primary-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600 lg:w-[260px]">무료 상담 신청하기 →</a></div></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <img src="/inquiry-landing/hero/icon-hospital.svg" alt="" aria-hidden={true} width={16} height={16} className="mt-0.5 size-4 shrink-0 lg:mt-0" />;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <section id="hero" className="w-full overflow-hidden bg-[#f4f6f8]" style={t0}><div className="mx-auto flex max-w-[1140px] flex-col items-center gap-12 px-5 pb-[30px] pt-10 lg:gap-16 lg:px-0 lg:pb-10 lg:pt-[84px]">{t9}<div className="flex w-full max-w-[320px] items-start justify-center gap-1.5 lg:max-w-none lg:items-center lg:gap-2">{t10}<p className="break-keep text-center text-[15px] leading-[1.4] tracking-[-0.07px] text-[#727272] lg:text-[15px]">성형외과, 피부과, 치과, 정형외과, 한의원을 포함한 <br aria-hidden={true} className="sm:hidden" /><span className="font-bold">모든 진료과목의 병의원</span>에 적용할 수 있습니다.</p></div></div></section>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  return t11;
};
export default Hero;